import React, { useEffect, useState } from "react";
import { Card, Form, Input, Button, message, Row, Col } from "antd";
import API from "../../api";
import ChangePasswordDrawer from "./ChangePasswordDrawer";

const Profile = () => {
  const [user, setUser] = useState(null);
  const [form] = Form.useForm();
  const [isDrawerOpen, setDrawerOpen] = useState(false);

  const userData = JSON.parse(localStorage.getItem("userData")); // Assuming `userData` is stored in localStorage

  const fetchUser = async () => {
    try {
      const response = await API.get(`/users/${userData.id}`);
      setUser(response?.data);
      console.log(response?.data)
      form.setFieldsValue({
        ...response?.data,
        role: response.data?.role?.name || "",
        branch: response.data?.storeId?.name || "", // Set branch name dynamically
      });
    } catch (error) {
      message.error("Failed to fetch user data!");
      console.error("Error fetching user:", error);
    }
  };

  const onFinish = async (values) => {
    try {
      const response = await API.put(`/users/${userData?.id}`, values.name);

      message.success("Profile updated successfully!");
    } catch (error) {
      message.error(error.response?.data?.message);
      console.error("Error updating profile:", error);
    }
  };

  useEffect(() => {
    fetchUser();
  }, []);

  const changePassword = () => {
    prompt("enter password:");
  };

  return (
    <div style={{
      padding: "20px",
      background: "#fff",
      borderRadius: "8px",
      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.05)",
    }}>

<Card
      title="Profile Information"
      style={{
        maxWidth: 600,
        margin: "0 auto",
        padding: "16px",
        width: "100%", // Ensure it adapts to the width of the screen
      }}
    >
      <Form form={form} layout="vertical" onFinish={onFinish}>
        <Form.Item
          label="Name"
          name="name"
          rules={[{ required: true, message: "Please input your name!" }]}
        >
          <Input placeholder="Enter your name" />
        </Form.Item>

        <Form.Item
          label="Email"
          name="email"
          rules={[
            {
              required: true,
              type: "email",
              message: "Please input a valid email!",
            },
          ]}
        >
          <Input placeholder="Enter your email" disabled />
        </Form.Item>

        <Form.Item label="Role" name="role">
          <Input placeholder="Role" disabled />
        </Form.Item>

        {user?.role?.name != 'admin' && <Form.Item label="Branch" name="branch">
          <Input placeholder="Branch name" disabled />
        </Form.Item>}

        <Row gutter={8} justify="space-between" align="middle">
          <Col xs={24} sm={12} md={8}>
            <Form.Item>
              <Button type="primary" htmlType="submit" block>
                Save Changes
              </Button>
            </Form.Item>
          </Col>

          <Col xs={24} sm={12} md={8}>
            <Form.Item>
              <Button type="link" onClick={() => setDrawerOpen(true)} block>
                Change Password
              </Button>
            </Form.Item>
          </Col>
        </Row>
      </Form>
      <ChangePasswordDrawer open={isDrawerOpen} setOpen={setDrawerOpen} />
    </Card>

    </div>
    
  );
};

export default Profile;
